'use strict';

import util from './util';
import modalExport from './modal';
const modal = modalExport.global;
import ajax from './ajax';
var sampleCookieName = "sample.selection.shown",
    cartPage = $("body").hasClass("cart_page");
	

/**
 * Creates sample selection cookie
 */
var createSelectionShownCookie = function () {
	util.setCookie(sampleCookieName, "1");
}

/**
 * Checks if sample selection cookie exists
 * @return {boolean}
 */
var canShowSelection = function () {
	return (!SitePreferences.SAMPLES_ENABLED) ? false : true;
}

/**
 * Render Samples
 * @return {boolean}
 */
var showSelection = function () {
	// set selection cookie
	//createSelectionShownCookie();
	var sampleUrl = Urls.showSampleSelection;
	// render content to modal by url
	modal.addCustomClass('sample-selection');
	$('.sample-selection').parent('.reveal-overlay').addClass('sample-overlay');
	sampleUrl = sampleUrl;
	modal.renderByUrl(sampleUrl);
}

var showSelectionInCart = function () {
	// render content to modal by url
	if(cartPage) {
		modal.addCustomClass('sample-selection sample-selection-redesign ');
		modal.setCallback(function() {
			if($('.reveal.sample-selection-redesign').find('.product-tile-wrapper').length <=  6) {
				$('.reveal#modal-cntr').addClass('modal-cntr-noscroll');
				if($(window).width() < 768) {
					if($('.reveal.sample-selection-redesign').find('.product-tile-wrapper').length < 4) {
						$('.reveal .product-listing').addClass('product-listing-noscroll');
					} else {
						$('.reveal .product-listing').scrollBox();
						setTimeout(() => {
							$('.reveal .product-listing').trigger('resize.scrollBox');
						},  500);
					}
				} else {
					$('.reveal .product-listing').addClass('product-listing-noscroll');
				}

				if($('.reveal.sample-selection-redesign').find('.product-tile-wrapper').length == 1) {
					$('.reveal#modal-cntr').addClass('modal-cntr-onesample');
				} else if($('.reveal.sample-selection-redesign').find('.product-tile-wrapper').length == 2) {
					$('.reveal#modal-cntr').addClass('modal-cntr-two-sample');
				} else if($('.reveal.sample-selection-redesign').find('.product-tile-wrapper').length == 3) {
					$('.reveal#modal-cntr').addClass('modal-cntr-three-sample');
				} else if($('.reveal.sample-selection-redesign').find('.product-tile-wrapper').length == 4) {
					$('.reveal#modal-cntr').addClass('modal-cntr-four-sample');
				} else if($('.reveal.sample-selection-redesign').find('.product-tile-wrapper').length > 4) {
					$('.reveal#modal-cntr').addClass('modal-cntr-five-sample');
				}
			} else {
				$('.reveal .product-listing').scrollBox();
				setTimeout(() => {
					$('.reveal .product-listing').trigger('resize.scrollBox');
				}, 500);
				$('.reveal#modal-cntr').addClass('modal-cntr-five-sample');
			}
			setTimeout(() => {
				if($('.reveal .sample-popup-header').height() > 20) {
					$('.reveal .product-listing').addClass('sample-popup-header__two-lines')
				}
			}, 500);
		});
	} else {
		modal.addCustomClass('sample-selection');
	}
	$('.sample-selection').parent('.reveal-overlay').addClass('sample-overlay');
	var sampleUrlCart = Urls.showSampleSelectionInCart;
	sampleUrlCart = sampleUrlCart;
	modal.renderByUrl(sampleUrlCart);
}

export default { createSelectionShownCookie, canShowSelection, showSelection, showSelectionInCart };